import api from "../../../public/config.js";

// split host url and port from domain if localhost exists
const localhostUrl = location.host.split(":");
const apiBaseUrl = api.apiBaseUrl.includes("localhost")
    ? api.apiBaseUrl.replace("localhost", localhostUrl[0])
    : api.apiBaseUrl;
const msubsBaseUrl = apiBaseUrl + "api/";

const apiEndpoints = {
    host_url: apiBaseUrl,
    login: msubsBaseUrl + "login",
    register: msubsBaseUrl + "register",
    sent_email_otp: msubsBaseUrl + "sent-email-otp",
    verify_email: msubsBaseUrl + "verify-email",
    logout: msubsBaseUrl + "logout",
    get_roles: msubsBaseUrl + "roles",
    enable_mfa: msubsBaseUrl + "users/enable-mfa",
    add_user_credit: msubsBaseUrl + "users/add-credits",
    create_user: msubsBaseUrl + "users/create",
    get_users: msubsBaseUrl + "users",
    get_guest_user: msubsBaseUrl + "get-guest-user",
    update_user: msubsBaseUrl + "users/update",
    delete_user: msubsBaseUrl + "users/delete",
    get_usernames: msubsBaseUrl + "users/usernames",
    update_profile: msubsBaseUrl + "users/update-profile",
    change_password: msubsBaseUrl + "users/change-password",
    get_user_credits_info: msubsBaseUrl + "users/get-user-credits-info",
    get_jobs: msubsBaseUrl + "jobs/",
    download_srt_files: msubsBaseUrl + "jobs/download-file",
    download_live_subtitles: msubsBaseUrl + "jobs/download-live-subtitles",
    get_live_jobs: msubsBaseUrl + "jobs/live",
    get_translation_jobs: msubsBaseUrl + "jobs/translation",
    get_usage_reports: msubsBaseUrl + "reports/",
    get_usage_reports_v2: msubsBaseUrl + "reports/v2",
    download_usage_reports: msubsBaseUrl + "reports/download/",
    get_customer_list: msubsBaseUrl + "reports/get-customers",
    view_job: msubsBaseUrl + "jobs/view",
    view_live_job: msubsBaseUrl + "jobs/live-view",
    cancel_live_job: msubsBaseUrl + "jobs/cancel-live-job",
    get_live_captions: msubsBaseUrl + "jobs/get-live-captions",
    update_live_captions: msubsBaseUrl + "jobs/update-live-captions",
    delete_job: msubsBaseUrl + "jobs/delete-job",
    delete_live_job: msubsBaseUrl + "jobs/delete-live-job",

    get_transcription_languages: msubsBaseUrl + "transcription-languages/",
    get_live_transcription_languages: msubsBaseUrl + "live/transcription-languages/",
    get_translation_languages: msubsBaseUrl + "translation-languages/",
    create_job: msubsBaseUrl + "jobs/create",
    create_live_job: msubsBaseUrl + "jobs/create-live",
    create_translation_job: msubsBaseUrl + "jobs/create-translation",
    create_qc_output: msubsBaseUrl + "jobs/create-qc-output",
    // delete_qc_output_file: msubsBaseUrl + "jobs/delete-qc-output-file",
    complete_job: msubsBaseUrl + "jobs/complete-job",
    get_models: msubsBaseUrl + "models/",
    make_translation_analysis: msubsBaseUrl + "tools/translate-quality",
    importSrtFile: msubsBaseUrl + "edit-subtitles/import-srt-file",
    exportSrtFile: msubsBaseUrl + "edit-subtitles/export-srt-file",
    exportSubtitle: msubsBaseUrl + "edit-subtitles/export-subtitle",
    importSrtVttFile: msubsBaseUrl + "edit-subtitles/import-srt-vtt-file",
    updateJobName: msubsBaseUrl + "edit-subtitles/update-job-name",
    generateWaveform: msubsBaseUrl + "edit-subtitles/generate-waveform",
    getWaveform: msubsBaseUrl + "edit-subtitles/get-waveform",
    updateConfig: msubsBaseUrl + "edit-subtitles/update-config",
    createVersion: msubsBaseUrl + "edit-subtitles/create-version",

    get_app_settings: msubsBaseUrl + "app-settings/",
};

export default apiEndpoints;
